import { gql } from "@apollo/client";import { useLazyQuery } from "@apollo/client/react";import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { FormControl, Grid, Box, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import AuditoriaDataGrid from './AuditoriaDataGrid';

import { DateInput } from '../../../components/dateInput/DateInput';
import moment from 'moment';
import 'moment/locale/es';
import Cookies from 'universal-cookie';
import ErrorDialog from '../../../components/ErrorDialog';
import { CustomButton } from '../../../components/customButton/CustomButton';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { usePersistFilters } from '../../../hooks/usePersistFilters';

const locale = "es-ES";

export default function AuditoriaFilter() {
  const titulo = 'Administración de Auditoria';

  const [state, setState] = useState({
    showDataGrid: false,
    data: ''
  });

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [dataOriginal, setDataOriginal] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const { filters: filtro, handleChangeFilters } = usePersistFilters({
    accion: '-1',
    fechaDesde: moment().format("yyyy-MM-DD"),
    fechaHasta: moment().format("yyyy-MM-DD"),
    txtFiltro: ''
  }, "auditoriaFilters");

  const handleChangeFechaDesde = (value) => {
    handleChangeFilters("fechaDesde", value);
  };

  const handleChangeFechaHasta = (value) => {
    handleChangeFilters("fechaHasta", value);
  };


  const handleChangeAccion = (event) => {
    handleChangeFilters("accion", event.target.value);
  };

  const QAuditoria = gql`
    query QAuditoria($accion: String!, $fechaDesde: String!, $fechaHasta: String!){
          auditoria(filtros: { accion: $accion, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta }) 
            {
              success,
              error,
              valorEsperado {
                id,
                usuario,
                idUsuario,
                pcUsuario,
                ipUsuario,
                fecha,
                accion,
                descripcionAccion,
                idClave,
                longitud,
                latitud         
              }
            }
          }`;

  const handleClickSearch = () => {
    if (isFormValid()) {
      Search();
    }
  };

  const isFormValid = () => {
    if (filtro.fechaDesde === null) {
      toast.error('Debe ingresar el campo Fecha Desde.');
      return false;
    }
    if (filtro.fechaHasta === null) {
      toast.error('Debe ingresar el campo Fecha Hasta.');
      return false;
    }
    if (filtro.accion === ' ') {
      toast.error('Debe seleccionar el campo Accion.');
      return false;
    }

    return true;
  };

  const [getAuditoria, { loading: loadingAuditoria, error: errorAuditoria, data: dataAuditoria }] = useLazyQuery(QAuditoria, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataAuditoria || loadingAuditoria) return;
    if (dataAuditoria.auditoria.success) {
      setDataOriginal(dataAuditoria.auditoria.valorEsperado); // Guardar datos originales
      setFilteredData(dataAuditoria.auditoria.valorEsperado);
      setState((prevState) => {
        return {
          ...prevState,
          showDataGrid: true,
          data: dataAuditoria.auditoria.valorEsperado
        };
      });
    } else if (dataAuditoria.auditoria.error === 'ERRORDB' || parseInt(dataAuditoria.auditoria.error, 10) > 0) {
      setMensajeError(dataAuditoria.auditoria.error);
    }
  }, [dataAuditoria]);

  useEffect(() => {
    if (!errorAuditoria) return;
    setMensajeError("ERRORDB");
  }, [errorAuditoria]);

  const Search = () => {
    const fechaDesde = moment(filtro.fechaDesde).format("yyyy-MM-DD");
    const fechaHasta = moment(filtro.fechaHasta).format("yyyy-MM-DD");
    let accion = filtro.accion;

    let result = getAuditoria({ variables: { accion: accion, fechaDesde: fechaDesde, fechaHasta: fechaHasta } });
  };

  useEffect(() => {
    getAuditoria({
      variables: {
        accion: filtro.accion,
        fechaDesde: filtro.fechaDesde,
        fechaHasta: filtro.fechaHasta
      }
    });
  }, []);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const handleSearch = (event) => {
    const input = event.target.value.trim().toLowerCase();

    handleChangeFilters("txtFiltro", input);

    if (input.length >= 3) {
      const filtered = dataOriginal.filter((item) => {
        const usuario = item.usuario.toLowerCase();
        const ipUsuario = item.ipUsuario?.toLowerCase() || '';
        const idClave = item.idClave?.toString() || '';
        const descripcionAccion = item.descripcionAccion?.toLowerCase() || '';

        return (
          usuario.includes(input) ||
          ipUsuario.includes(input) ||
          idClave.includes(input) ||
          descripcionAccion.includes(input));

      });
      setFilteredData(filtered); // Actualiza los datos filtrados
    } else {
      setFilteredData(dataOriginal); // Si hay menos de 3 caracteres, muestra todos los datos originales
    }
  };


  return (
    <>
            <Box sx={{ width: '100%' }}>
                <Grid container direction="row" spacing={2}>
                    <Grid size={{ xs: 6, sm: 3, md: 3, lg: 2 }}>
                        <DateInput
              label="Fecha Desde"
              value={filtro.fechaDesde}
              onChange={handleChangeFechaDesde} />
            
                    </Grid>
                    <Grid size={{ xs: 6, sm: 3, md: 3, lg: 2 }}>
                        <DateInput
              label="Fecha Hasta"
              value={filtro.fechaHasta}
              onChange={handleChangeFechaHasta} />

            
                    </Grid>
                    <Grid size={{ xs: 12, sm: 3, md: 3, lg: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel id="slAccion-lbl">Acción</InputLabel>
                            <Select
                labelId="slAccion-lbl"
                id="slAccion"
                name="accion"
                value={filtro.accion}
                label="Acción"
                onChange={handleChangeAccion}
                sx={{ fontSize: 13, height: "40px", backgroundColor: 'white' }}>
                
                                <MenuItem value={'-1'} sx={{ fontSize: 13 }}>TODOS</MenuItem>
                                <MenuItem value={'1'} sx={{ fontSize: 13 }}>ALTA</MenuItem>
                                <MenuItem value={'2'} sx={{ fontSize: 13 }}>BAJA</MenuItem>
                                <MenuItem value={'3'} sx={{ fontSize: 13 }}>MODIFICACION</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                        <FormControl size="small">
                            <div style={{ display: 'flex', width: '100%' }}>
                                <TextField
                  label="Filtrar"
                  name="txtFiltro"
                  size="small"
                  type="text"
                  variant="outlined"
                  value={filtro.txtFiltro}
                  onChange={handleSearch}
                  sx={{ backgroundColor: 'white' }}
                  InputProps={{
                    endAdornment:
                    <InputAdornment position="end">
                                                <SearchIcon onClick={handleSearch} sx={{ cursor: 'pointer' }} />
                                                <ClearIcon onClick={() => {handleChangeFilters("txtFiltro", '');setFilteredData(dataOriginal);}} sx={{ cursor: 'pointer' }} />
                                            </InputAdornment>

                  }} />
                
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 2, md: 2, lg: 2 }}>
                        <CustomButton
              variant="contained"
              size="small"
              onClick={handleClickSearch}
              endIcon=''
              style={{ float: "right" }}>
              Buscar</CustomButton>
                    </Grid>
                </Grid>
            </Box>
            {/* <div style={{ display: 'flex', width: '100%', paddingTop: '3%' }}>
           <div style={{ fontSize: '13pt' }}>
               <FormControl size="small">
                   <div style={{ display: 'flex', width: '100%' }}>
                       <TextField
                           label="Filtrar"
                           name="txtFiltro"
                           size="small"
                           type="text"
                           variant="outlined"
                           value={filtro.txtFiltro}
                           onChange={handleSearch}
                           sx={{ backgroundColor: 'white' }}
                           InputProps={{
                               endAdornment: (
                                   <InputAdornment position="end">
                                       <SearchIcon onClick={handleSearch} sx={{ cursor: 'pointer' }} />
                                       <ClearIcon onClick={() => { handleChangeFilters("txtFiltro", ''); setFilteredData(dataOriginal); }} sx={{ cursor: 'pointer' }} />
                                   </InputAdornment>
                               ),
                           }}
                       />
                   </div>
               </FormControl>
           </div>
        </div> */}
            <br />
            <AuditoriaDataGrid rows={filteredData} />
            <ErrorDialog
        id="dlg-error-terminos"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </>);


};